import { render, staticRenderFns } from "./LeadReceipts.vue?vue&type=template&id=1302b0da&scoped=true"
import script from "./LeadReceipts.vue?vue&type=script&lang=js"
export * from "./LeadReceipts.vue?vue&type=script&lang=js"
import style0 from "./LeadReceipts.vue?vue&type=style&index=0&id=1302b0da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1302b0da",
  null
  
)

export default component.exports